import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";
import GenericFlowExport from "./export-tables/generic-flow-export.jsx";
import TableBody from "./table-body.jsx";

const AverageDataset = ({ data }) => {
    const averageDatasets = data?.averageDatasets || [];

    useEffect(() => {
        const labels = averageDatasets[0]?.data.map(e => e.time) || [];

        const dataColumns = averageDatasets.map(averageDataset => {
            const values = averageDataset.data.map(e => parseFloat(e.qty) || 0);

            return [averageDataset.title, ...values];
        });
        GraphicUtils.lineChart(`traffic-flow-average`, dataColumns, labels, "Intervalo de horas", "Quantidade média de veículos", false, 999);

        const hasAnyData = averageDatasets.some(dataset => dataset.data.some(e => parseFloat(e.qty) > 0));
        if (hasAnyData) {
            ReportUtils.createExportableTable(null, null, `Fluxo veicular médio`, 'average-export');
        }
    }, [data])

    return (
        <>
            <TableBody title={"Fluxo veicular médio por hora"} id={"traffic-flow-average"}/>

            <GenericFlowExport datasets={averageDatasets} flow={"Média"} sheetName={"average-export"}/>
        </>
    );
};

export default AverageDataset;